// extracted by mini-css-extract-plugin
module.exports = {"container":"TextSpinner_container__yvhUJ","text":"TextSpinner_text__0Yu71"};